const INITIAL_DATA = {
  showHeader: true,
  showMobileMenu: false,
  showDesktopMenus: true,
  showTermsAndConditions: false,
}

const state = () => Object.assign({}, INITIAL_DATA)

const mutations = {
  SET_SHOW_HEADER(state, showHeader) {
    state.showHeader = showHeader
  },
  SET_SHOW_MOBILE_MENU(state, showMobileMenu) {
    state.showMobileMenu = showMobileMenu
  },
  SET_SHOW_DESKTOP_MENUS(state, showDesktopMenus) {
    state.showDesktopMenus = showDesktopMenus
  },
  SET_TERMS_AND_CONDITIONS(state, showTermsAndConditions) {
    state.showTermsAndConditions = showTermsAndConditions
  },
}
const actions = {
  setShowHeader({ commit }, showHeader) {
    commit('SET_SHOW_HEADER', showHeader)
  },
  setShowMobileMenu({ commit }, showMobileMenu) {
    commit('SET_SHOW_MOBILE_MENU', showMobileMenu)
  },
  setShowDesktopMenus({ commit }, showDesktopMenus) {
    commit('SET_SHOW_DESKTOP_MENUS', showDesktopMenus)
  },
  setTermsAndConditions({ commit }, showTermsAndConditions) {
    commit('SET_TERMS_AND_CONDITIONS', showTermsAndConditions)
  },
}

const getters = {
  showHeader(state) {
    return state.showHeader
  },
  showMobileMenu(state) {
    return state.showMobileMenu
  },
  showDesktopMenus(state) {
    return state.showDesktopMenus
  },
  showTermsAndConditions(state) {
    return state.showTermsAndConditions
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
